<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>

<div class="brands-header">
  <div class="left-side">
    <div class="content-wrapper">
      <div class="title">{{'BRANDS_PAGE.title_1' | translate}}</div>
      <div class="text">{{'BRANDS_PAGE.text_1' | translate}}
      </div>
      <button (click)="goToDemoPage()" class="cta-button">{{'BRANDS_PAGE.cta_1' | translate}}</button>
    </div>
  </div>
  <div class="right-side">
    <img [src]="isMobile ?
    'assets/images/png/brands_page_banner_mobile.png':'assets/images/png/brands_page_banner.png'"
         alt="People working together"/>
  </div>
</div>

<div class="message-container">
  <div class="title">{{'BRANDS_PAGE.title_2' | translate}}</div>
  <div class="subtitle">{{'BRANDS_PAGE.text_2' | translate}}</div>
</div>

<div class="impact-wrapper-wrapper">
  <div *ngIf="impactData" class="impact-wrapper">
    <div class="card-wrapper education-card">
      <img alt="education" class="card-image" loading="lazy" src="/assets/icons/north_star/education_color.svg">
      <div class="card-number">{{ impactData.education | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.education_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper biodiversity-card">
      <img alt="biodiversity" class="card-image" loading="lazy" src="/assets/icons/north_star/biodiversity_color.svg">
      <div class="card-number">{{ impactData.biodiversity | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.biodiversity_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper reforestation-card">
      <img alt="reforestation" class="card-image" loading="lazy" src="/assets/icons/north_star/reforestation_color.svg">
      <div class="card-number">{{ impactData.reforestation | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.reforestation_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper diverse-actions-card">
      <img alt="diverse-actions" class="card-image" loading="lazy"
           src="/assets/icons/north_star/diverse_actions_color.svg">
      <div class="card-number">{{ impactData.diverse_actions | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.diverse_actions_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper health-card">
      <img alt="health" class="card-image" loading="lazy" src="/assets/icons/north_star/health_color.svg">
      <div class="card-number">{{ impactData.health | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.health_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper zero-waste-card">
      <img alt="zero-waste" class="card-image" loading="lazy" src="/assets/icons/north_star/zero_waste_color.svg">
      <div class="card-number">{{ impactData.zero_waste | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.zero_waste_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper inclusiveness-card">
      <img alt="inclusiveness" class="card-image" loading="lazy" src="/assets/icons/north_star/inclusiveness_color.svg">
      <div class="card-number">{{ impactData.inclusiveness | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.inclusiveness_impactpage" | translate }}</div>
    </div>
    <div class="card-wrapper carbon-offset-card">
      <img alt="carbon-offset" class="card-image" loading="lazy" src="/assets/icons/north_star/carbon_offset_color.svg">
      <div class="card-number">{{ impactData.carbon_offset + impactData.reforestation * 12.3 / 1000 | ceil }}</div>
      <div class="card-kpi">{{ "IMPACT_PAGE.carbon_offset_impactpage" | translate }}</div>
    </div>
  </div>
</div>

<div class="brands-wrapper">
  <div class="title">{{'BRANDS_PAGE.title_3' | translate}}</div>
  <div class="subtitle">{{'BRANDS_PAGE.text_3' | translate}}</div>
  <div *ngIf="brands" class="brands">
    <app-brand-card *ngFor="let brand of brands"
                    [logo]="brand.logo"
                    [picture]="brand.picture"
                    [slug]="brand.slug"
                    (click)="openBrandPage(brand.slug)"></app-brand-card>
  </div>
</div>
